import {apiGet} from '@api/api'
import {IShowLeague} from '@api/rank/league/getLeagueShow'

export const apiGetLeagueShowPrevious = async (before?: number) => {
    return apiGet<IShowLeague>(`leagues/previous?before=${before || ''}`)
}
